.questionContainer {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.questionRow {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: flex-start;
}

.questionNumber {
  flex-shrink: 0;
  font-size: 0.875rem;
}

.questionText {
  font-size: 0.875rem;
}

.answersRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.textareaContainer {
  width: 100%;
}
